export default [
  {
    path: '/',
    name: 'dashboard-komship',
    component: () => import('@/views/pages/komship/dashboard/Dashboard.vue'),
    meta: {
      name: 'dashboard-komship',
      routeToOrder: 'data-order',
      routeToTopCustomer: 'info-customer',
      routeToDataProduct: 'data-produk',
      routeToRincianSaldo: 'saldo-detail',
      routeToTicket: 'ticketing-user',
      resource: 'Dashboard Komship',
      action: 'read',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
]
